export class ToggleBodyRequest {
  toggleOn: boolean;
}
